import BaseFeature from '../../foundation/base/base';

class Accordion extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.element = element;

		const toggleId = `toggle-${this.instanceId}`;
		const contentId = `content-${this.instanceId}`;

		this.open = false;

		this.dom.toggle.id = toggleId;
		this.dom.toggle.setAttribute('aria-expanded', false);
		this.dom.toggle.setAttribute('aria-controls', contentId);

		this.dom.content.id = contentId;
		this.dom.content.setAttribute('aria-labelledby', toggleId);

		this.dom.toggle.addEventListener('click', this.toggleAccordion.bind(this));
	}

	toggleAccordion() {
		this.dom.toggle.setAttribute('aria-expanded', !this.open);

		if (this.open) {
			this.element.classList.remove('is-open');
		} else {
			this.element.classList.add('is-open');
		}

		this.open = !this.open;
	}
}

export default Accordion;
